/**
 * Papel timbrado extraído de `public/assets/TIMBRADO R MOTORS LTDA(1).docx`.
 * Atualize o .docx e recopie para `timbrado-r-motors.jpg` se o layout mudar.
 */
export const CONTRATO_VENDA_TIMBRADO = {
  /** Caminho em /public (servido em runtime como `${PUBLIC_URL}/assets/...`) */
  imagePath: '/assets/timbrado-r-motors.jpg',
  /** Margens do texto sobre o timbrado (px na tela / impressão) */
  paddingScreen: { top: 145, right: 52, bottom: 115, left: 52 },
  /** Margens do texto no PDF (@react-pdf, em pt) */
  paddingPdf: { top: 108, right: 42, bottom: 88, left: 42 },
};

/** URL absoluta do timbrado para geração de PDF no navegador. */
export const getContratoTimbradoUrl = (): string => {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${base}${publicUrl}${CONTRATO_VENDA_TIMBRADO.imagePath}`;
};

/**
 * Dados fixos da VENDEDORA (R MOTORS LTDA) e demais informações da loja no contrato.
 */
export const CONTRATO_VENDA_LOJA = {
  nome: 'R MOTORS LTDA',
  cnpj: '57.699.077/0001-19',
  endereco: 'Rodovia Estrada de Ribamar, nº 0',
  bairro: 'Aurora',
  cidade: 'São Luís',
  uf: 'MA',
  cep: '65.060-541',
  /** Local de entrega do veículo (cláusula 5.1 — mesma sede) */
  enderecoEntrega: 'Rodovia Estrada de Ribamar, nº 0',
  cidadeEntrega: 'São Luís',
  ufEntrega: 'MA',
  cepEntrega: '65.060-541',
  cidadeForo: 'São Luís',
  ufForo: 'MA',
  banco: 'Bradesco',
  agencia: '2293',
  contaCorrente: '32.831-6',
  /** Titular da conta (cláusula 4.2) */
  titularConta: 'R Motors Ltda',
  chavePix: 'rmotors.slz@gmail.com (E-mail)',
};
